import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-dropdown-search',
  templateUrl: './dropdown-search.component.html',
  styleUrls: ['./dropdown-search.component.scss'],
  standalone: false
})
export class DropdownSearchComponent implements OnInit, OnChanges {
  @Input() items: { id: number; name: string }[] = [];
  @Input() label: string = 'COMMON.TS.SINGLE';
  @Input() id: string = '';
  @Input() borderRadius: string = '0.8rem';
  @Input() alternateLook: boolean = false;
  @Input() reset: boolean = false;
  @Input() selectedItemId: number | null = null;

  @Output() selectedIdChange = new EventEmitter<number>();

  @ViewChild('dropdownButton', { static: false }) dropdownButton!: ElementRef<HTMLButtonElement>;

  filteredItems: { id: number; name: string }[] = [];
  searchValue: string = '';
  selectedId: number = 0;
  selectedItem: { id: number; name: string } | null = null;

  constructor() {}

  ngOnInit() {
    this.initializeComponent();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items'] && !changes['items'].firstChange) {
      this.initializeComponent();
    }

    if (changes['selectedItemId']) {
      if (changes['selectedItemId'].currentValue !== null && changes['selectedItemId'].currentValue !== undefined) {
        this.updateSelectedItemById();
      } else if (changes['selectedItemId'].currentValue === null || changes['selectedItemId'].currentValue === 0) {
        this.resetSelection();
      }
    }

    if (changes['reset'] && !changes['reset'].firstChange && changes['reset'].currentValue) {
      this.resetSelection();
    }
  }

  private initializeComponent() {
    this.filteredItems = [...this.items];
    
    if (this.selectedItemId !== null && this.selectedItemId !== undefined && this.selectedItemId !== 0) {
      this.updateSelectedItemById();
    } else {
      this.resetSelection();
    }
  }

  private updateSelectedItemById() {
  if (this.selectedItemId !== null && this.selectedItemId !== undefined && this.selectedItemId !== 0) {
    const foundItem = this.items.find(item => item.id === this.selectedItemId);
    if (foundItem) {
      this.selectedItem = { ...foundItem };
      this.selectedId = foundItem.id;
      if (this.selectedId !== this.selectedItemId) {
        this.selectedIdChange.emit(this.selectedId);
      }
    } else {
      this.resetSelection();
    }
  } else {
    this.resetSelection();
  }
}

  applySearchFilter() {
    const searchTerm = this.searchValue.toLowerCase().trim();
    if (searchTerm === '') {
      this.filteredItems = [...this.items];
    } else {
      this.filteredItems = this.items.filter(item =>
        item.name.toLowerCase().includes(searchTerm)
      );
    }
  }

  selectItem(item: { id: number; name: string }) {
    this.selectedItem = { ...item };
    this.selectedId = item.id;
    this.selectedIdChange.emit(this.selectedId);
    this.searchValue = '';
    this.applySearchFilter();
    
    this.closeDropdown();
  }

  private closeDropdown() {
    if (this.dropdownButton && this.dropdownButton.nativeElement) {
      this.dropdownButton.nativeElement.click();
    }
  }

  resetSelection() {
    const previousId = this.selectedId;
    this.selectedItem = null;
    this.selectedId = 0;
    this.searchValue = '';
    this.filteredItems = [...this.items];
    if (previousId !== 0) {
      this.selectedIdChange.emit(0);
    }
  }
}